import { render, staticRenderFns } from "./Variable.vue?vue&type=template&id=1ad061ad&scoped=true&"
import script from "./Variable.vue?vue&type=script&lang=js&"
export * from "./Variable.vue?vue&type=script&lang=js&"
import style0 from "./Variable.vue?vue&type=style&index=0&id=1ad061ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad061ad",
  null
  
)

export default component.exports